"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChunksClient = void 0;
const utils_1 = require("../../utils");
class ChunksClient {
    constructor(client) {
        this.client = client;
    }
    /**
     * Create multiple chunks.
     * @param chunks List of UnprocessedChunk objects containing:
                - id: Optional UUID
                - document_id: Optional UUID
                - collection_ids: list UUID
                - metadata: dict
                - text: string
      * @param runWithOrchestration Optional flag to run with orchestration
      * @returns
      */
    async create(options) {
        return this.client.makeRequest("POST", "chunks", {
            data: {
                raw_chunks: (0, utils_1.ensureSnakeCase)(options.chunks),
                runWithOrchestration: options.runWithOrchestration,
            },
        });
    }
    /**
     * Update an existing chunk.
     * @param id ID of the chunk to update
     * @param text Optional new text for the chunk
     * @param metadata Optional new metadata for the chunk
     * @returns
     */
    async update(options) {
        return this.client.makeRequest("POST", `chunks/${options.id}`, {
            data: options,
        });
    }
    /**
     * Get a specific chunk.
     * @param id ID of the chunk to retrieve
     * @returns
     */
    async retrieve(options) {
        return this.client.makeRequest("GET", `chunks/${options.id}`);
    }
    /**
     * Delete a specific chunk.
     * @param id ID of the chunk to delete
     * @returns
     */
    async delete(options) {
        return this.client.makeRequest("DELETE", `chunks/${options.id}`);
    }
    /**
     * List chunks.
     * @param includeVectors Include vector data in response. Defaults to False.
     * @param metadataFilters Filter by metadata. Defaults to None.
     * @param offset Specifies the number of objects to skip. Defaults to 0.
     * @param limit Specifies a limit on the number of objects to return, ranging between 1 and 100. Defaults to 100.
     * @returns
     */
    async list(options) {
        var _a, _b;
        const params = {
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : 0,
            limit: (_b = options === null || options === void 0 ? void 0 : options.limit) !== null && _b !== void 0 ? _b : 100,
        };
        if (options === null || options === void 0 ? void 0 : options.includeVectors) {
            params.include_vectors = options.includeVectors;
        }
        if (options === null || options === void 0 ? void 0 : options.metadataFilters) {
            params.metadata_filters = options.metadataFilters;
        }
        return this.client.makeRequest("GET", "chunks", {
            params,
        });
    }
}
exports.ChunksClient = ChunksClient;
//# sourceMappingURL=chunks.js.map